<script lang="ts">
export interface ProseH6Props {
  id?: string
  class?: any
}

export interface ProseH6Slots {
  default: (props?: object) => unknown
}
</script>

<script setup lang="ts">
const props = defineProps<ProseH6Props>()
defineSlots<ProseH6Slots>()
</script>

<template>
  <h6
    :id
    class="my-1 text-base font-semibold"
    :class="props.class"
  >
    <slot />
  </h6>
</template>
